import React from "react";
import SubmitRequestIcon from "../../../../icons/submitRequest.svg";
import OnlineApplicationIcon from "../../../../icons/onlineApplication.svg";
import ReviewApprovalIcon from "../../../../icons/reviewApproval.svg";
import PrintPolicyIcon from "../../../../icons/printPolicy.svg";
import { SvgIcon } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    lightBackground: {
        backgroundColor: `${theme.palette.primary.main}16`,
    },
}));
export function NextStep(props) {
    const classes = useStyles();
    const StepList = [
        {
            title: "Submit your Request",
            icon: SubmitRequestIcon,
        },
        {
            title: `Complete your easy online application with ${props.carrierName}`,
            icon: OnlineApplicationIcon,
        },
        {
            title: `Review your ${props.isHavenLifeSIProduct || props.isHavenTermProduct ? 'decision' : 'approval'}<br/>within minutes`,
            icon: ReviewApprovalIcon,
        },
        {
            title: `${props.isHavenLifeSIProduct || props.isHavenTermProduct ? 'If approved, print' : 'Print'} and file your policy!`,
            icon: PrintPolicyIcon,
        }
    ]
    const LGAStepList = [
        {
            title: "Complete your entire application online",
            icon: SubmitRequestIcon,
            sublist: [
                {
                    subtitle: "It only takes about 15 minutes!"
                }
            ]
        },
        {
            title: "Have the following information handy",
            icon: OnlineApplicationIcon,
            sublist: [
                {
                    subtitle: "Driver's License and SSN"
                },
                {
                    subtitle: "Name of Doctor(s)"
                },
                {
                    subtitle: "Name of any medications that <br> you're taking"
                }
            ]
        },
        {
            title: "Electronically sign your application",
            icon: ReviewApprovalIcon,
        }
    ]
    return (
        <div className="step-list">
            {props.isLgaProduct ? LGAStepList.map((item, key) =>
                <div>
                    <ul key={key}>
                        <li>
                            <div className={`icon-container ${classes.lightBackground}`}>
                                <SvgIcon component={item.icon} color='primary' />
                            </div><span className="lga-title" dangerouslySetInnerHTML={{ __html: item.title }} />
                        </li>
                    </ul>
                    <div className="sub-list">
                        <ul className="step-sub-list mb-0">
                            {item.sublist && item.sublist.map((item, key) => (
                                <li key={key} className="list-item mb-2"><span dangerouslySetInnerHTML={{ __html: item.subtitle }} />
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ) :
                <ul>
                    {StepList.map((item, key) => (
                        <li key={key}>
                            <div className={`icon-container ${classes.lightBackground}`}>
                                <SvgIcon component={item.icon} color='primary' />
                            </div><span dangerouslySetInnerHTML={{ __html: item.title }} />
                        </li>
                    ))}
                </ul>
            }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/InsuranceRequest/NextStep.js